import { render, staticRenderFns } from "./Government.vue?vue&type=template&id=9e51617c&scoped=true"
import script from "./Government.vue?vue&type=script&lang=js"
export * from "./Government.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e51617c",
  null
  
)

export default component.exports